<template>
  <div class="home">
    <HomeCarousel 
      :carouselData="banners"
      :interval="5000"
    />
    
    <div class="main-content">
      <section class="company-intro" data-aos="fade-up">
        <div class="intro-top">
          <div class="logo-wrapper">
            <img src="@/assets/logo.png" alt="苏润人才" class="company-logo">
          </div>
          <div class="intro-text" v-if="en" v-html="companyInfo.descriptionen"></div>
          <div class="intro-text" v-else v-html="companyInfo.description"></div>
          <div class="action-buttons">
            <div 
              class="action-btn"
              @click="scrollToSection('culture')"
               @mouseover="srcicon = hoverIcon" 
              @mouseleave="srcicon = defaultIcon"
            >
              {{ $t('home.companyCulture') }}
              <img class="action-icon" :src="srcicon"  alt="更多箭头">
            </div>
            <div 
              class="action-btn"
              @click="scrollToSection('history')"
              @mouseover="srcicon1 = hoverIcon1" 
              @mouseleave="srcicon1 = defaultIcon1"
            >
              {{ $t('home.developmentHistory') }}
              <img class="action-icon" :src="srcicon1"   alt="更多箭头">
            </div>
          </div>
        </div>
        
        <div class="intro-bottom">
          <div class="blue-block">
            <div class="text-content">
              <h2>{{ $t('home.wantToKnowMore') }}</h2>
              <p>{{ $t('home.wantToKnowMoreEn') }}</p>
              <router-link to="/group" class="circle-arrow">
                <img class="arrow-icon" src="../assets/home/gengduo.png" alt="箭头">
              </router-link>
            </div>
          </div>
          <div class="image-container">
            <img :src="companyInfo.group" alt="Building" class="building-image">
          </div>
        </div>
      </section>
      
      <!-- 产品与服务 -->
      <section class="products-services">
        <div class="section-title" data-aos="fade-up">
          <h3 class="en-title">PRODUCTS AND SERVICES</h3>
          <h2 class="cn-title">产品与服务</h2>
        </div>
        
        <div class="service-container">
          <!-- 第一行 -->
          <div class="service-row" data-aos="fade-up" data-aos-delay="200">
            <div class="service-item large">
              <div class="service-content">
                <h2 class="service-cn-title">人才全生命周期服务</h2>
                <h3 class="service-en-title">Talent Lifecycle Services</h3>
    
                <router-link to="/talent" class="learn-more">{{ $t('home.more') }}
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </router-link>
              </div>
              <div class="gradient-overlay gradient-1"></div>
              <img  :src="companyInfo.talent" alt="人才全生命周期服务" class="service-bg">
            </div>
            <div class="service-item">
              <div class="service-content">
                <h2 class="service-cn-title">人才计划解读</h2>

                <h3 class="service-en-title">Interpretation of Talent Programs</h3>
                <router-link to="/talent/plan" class="learn-more">{{ $t('home.more') }}
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </router-link>
              </div>
              <div class="gradient-overlay gradient-2"></div>
              <img  :src="companyInfo.plan" alt="人才计划解读" class="service-bg">
            </div>
          </div>
          
          <!-- 第二行 -->
          <div class="service-row" data-aos="fade-up" data-aos-delay="400">
            <div class="service-item">
              <div class="service-content">
                <h2 class="service-cn-title">企业服务</h2>

                <h3 class="service-en-title">Enterprise Services</h3>
                <router-link to="/enterprise/lifecycle" class="learn-more">{{ $t('home.more') }}
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </router-link>
              </div>
              <div class="gradient-overlay gradient-3"></div>
              <img  :src="companyInfo.enterprise" alt="企业服务" class="service-bg">
            </div>
            <div class="service-item">
              <div class="service-content">
                <h2 class="service-cn-title">政府服务</h2>

                <h3 class="service-en-title">Government Services</h3>
                <router-link to="/government/service" class="learn-more">{{ $t('home.more') }}
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </router-link>
              </div>
              <div class="gradient-overlay gradient-4"></div>
              <img :src="companyInfo.government" alt="政府服务" class="service-bg">
            </div>
            <div class="service-item">
              <div class="service-content">
                <h2 class="service-cn-title">科创活动</h2>

                <h3 class="service-en-title">Science and Technology Innovation Activities</h3>
                <router-link to="/activity" class="learn-more">{{ $t('home.more') }}
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </router-link>
              </div>
              <div class="gradient-overlay gradient-5"></div>
              <img :src="companyInfo.activity" alt="科创活动" class="service-bg">
            </div>
          </div>
        </div>
      </section>

      <!-- 热门专题 -->
      <section class="hot-topics">
        <div class="section-title" data-aos="fade-up">
          <h3 class="en-title">HOT TOPICS</h3>
          <h2 class="cn-title">热门专题</h2>
        </div>
        <div class="topic-container">
          <!-- 人才招聘 -->
          <div class="topic-item" data-aos="fade-up" data-aos-delay="200">
            <div class="topic-header">
              <h2 class="topic-cn-title">人才招聘</h2>
              <br>
              <p class="topic-en-title">/Talent Recruitment</p>
              <div class="topic-line-wrapper">
                <div class="topic-line1"></div>
                <div class="topic-line2"></div>
              </div>
       
            </div>
            <div class="topic-list" v-if="recruitmentList.length > 0">
              <!-- 第一条数据（带图片） -->
              <div class="topic-list-header" v-if="recruitmentList.length > 0"  @click="viewzhaopin(recruitmentList[0])">
                <img class="topic-list-img" :src="recruitmentList[0].url" alt="人才招聘">
                <div class="topic-list-title">
                  <h2>{{ recruitmentList[0].title }}</h2>
                  <span>发布时间：{{ recruitmentList[0].createtime.split(' ')[0] }}</span>
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </div>
              </div>
              <!-- 剩余数据列表 -->
              <div 
                class="topic-list-item" 
                v-for="(item, index) in recruitmentList.slice(1)" 
                :key="index"
                @click="viewzhaopin(item)"
              >
                <div class="date">{{ item.createtime.split(' ')[0] }}</div>
                <div class="title">{{ item.title }}</div>
              </div>
            </div>
            <div class="topic-list" v-else>
              <img src="../assets/home/zanwuxuexineirong.png" alt="暂无数据" class="empty-img">
            </div>
          </div>
          
          <!-- 人才推荐 -->
          <div class="topic-item" data-aos="fade-up" data-aos-delay="400">
            <div class="topic-header">
              <h2 class="topic-cn-title">人才推荐</h2>
              <br>
              <p class="topic-en-title">/Talent Recommendation</p>
              <div class="topic-line-wrapper">
                <div class="topic-line1"></div>
                <div class="topic-line2"></div>
              </div>
            </div>
            <div class="topic-list" v-if="recommendList.length > 0">
              <!-- 第一条数据（带图片） -->
              <div class="topic-list-header" v-if="recommendList" @click="viewtuijian(recommendList[0])">
                <img class="topic-list-img" :src="recommendList[0].url" alt="人才推荐">
                <div class="topic-list-title">
                  <h2>{{ recommendList[0].title }}</h2>
                  <span>发布时间：{{ recommendList[0].createtime.split(' ')[0] }}</span>
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </div>
              </div>
              <!-- 剩余数据列表 -->
              <div 
                class="topic-list-item" 
                v-for="(item, index) in recommendList.slice(1)" 
                :key="index"
                @click="viewtuijian(item)"
              >
                <div class="date">{{ item.createtime.split(' ')[0] }}</div>
                <div class="title">{{ item.title }}</div>
              </div>
            </div>
            <div class="topic-list" v-else>
              <img src="../assets/home/zanwuxuexineirong.png" alt="暂无数据" class="empty-img">
            </div>
          </div>
          
          <!-- 课程中心 -->
          <div class="topic-item" data-aos="fade-up" data-aos-delay="600">
            <div class="topic-header">
              <h2 class="topic-cn-title">课程中心</h2>
              <br>
              <p class="topic-en-title">/Course Center</p>
              <div class="topic-line-wrapper">
                <div class="topic-line1"></div>
                <div class="topic-line2"></div>
              </div>
            </div>
            <div class="topic-list" v-if="courseList.length > 0">
              <!-- 第一条数据（带图片） -->
              <div class="topic-list-header" v-if="courseList.length > 0" @click="viewcourse(courseList[0])">
                <img class="topic-list-img" :src="courseList[0].url" alt="课程中心">
                <div class="topic-list-title">
                  <h2>{{ courseList[0].title }}</h2>
                  <span>发布时间：{{ courseList[0].createtime.split(' ')[0] }}</span>
                  <img src="../assets/home/gengduo.png" alt="了解更多">
                </div>
              </div>
              <!-- 剩余数据列表 -->
              <div 
                class="topic-list-item" 
                v-for="(item, index) in courseList.slice(1)" 
                :key="index"
                @click="viewcourse(item)"
              >
                <div class="date">{{ item.createtime.split(' ')[0] }}</div>
                <div class="title">{{ item.title }}</div>
              </div>
            </div>
            <div class="topic-list" v-else>
              <img src="../assets/home/zanwuxuexineirong.png" alt="暂无数据" class="empty-img">
            </div>
          </div>
        </div>
      </section>

      <!-- 人才专家库 -->
      <section class="expert-database">
        <div class="section-title" data-aos="fade-up">
          <div class="title-wrapper">
            <div class="title-left">
              <h3 class="en-title">TALENT EXPERT DATABASE</h3>
              <h2 class="cn-title">人才专家库</h2>
            </div>
            <router-link to="/expert" class="view-more" v-if="expertList.length > 0">
              {{ $t('home.viewMore') }} >>
            </router-link>
          </div>
        </div>
        
        <!-- 人才专家库内容部分 -->
        <div class="expert-container">
          <!-- 左侧视频区域 -->
          <div class="expert-video" data-aos="fade-right" data-aos-delay="200" v-if="interview.length > 0">
            <div class="video-wrapper" @click="playVideo">
              <img :src="interviewUrl" alt="视频封面">
              <div class="play-button">
                <img src="../assets/home/bofang.png" alt="播放">
              </div>
            </div>
            <div class="video-title-wrapper">
              <h3 class="video-title">{{interview[0].title}}</h3>
              <p class="video-date"><img src="../assets/home/shijian.png" alt="日期">{{interview[0].createtime.split(' ')[0]}}</p>
            </div>
          </div>
          <div v-else class="quexingimg">
            <img src="../assets/home/zanwuxuexineirong.png" alt="暂无数据" >
          </div>

          <!-- 右侧专家列表 -->
          <div class="expert-list" v-if="expertList.length > 0">
            <div 
              class="expert-item" 
              v-for="(expert, index) in expertList" 
              :key="index"
              @click="viewDetail(expert)"
              :data-aos="'fade-left'"
              :data-aos-delay="100 * (index + 1)"
            >
              <div class="expert-info">
                <h3 class="expert-name">{{ expert.name }}</h3>
                <div class="expert-tags">
                  <!-- 第一个标签（人才/专家） -->
                  <span 
                    class="tag" 
                    :class="expert.category === 1 ? 'talent' : 'expert'"
                  >
                    {{ expert.category === 1 ? '人才' : '专家' }}
                  </span>
                  <!-- 其他标签 -->
                  <span 
                    v-for="(tag, idx) in expert.type.split(',')" 
                    :key="idx" 
                    class="tag"
                    v-if="idx < 2"
                  >
                    {{ tag }}
                  </span>
                  <!-- 如果标签超过2个，显示... -->
                  <span 
                    v-if="expert.type.split(',').length > 2" 
                    class="tag more"
                  >
                    ...
                  </span>
                </div>
              </div>
              <p class="expert-desc">{{ filterRichText(expert.description) }}</p>
            </div>
          </div>
          <div v-else class="quexingimg">
            <img src="../assets/home/zanwuxuexineirong.png" alt="暂无数据">
          </div>
        </div>
      </section>
    </div>

    <!-- 视频弹窗组件 -->
    <div class="video-modal" v-if="showVideoModal" @click="closeVideo">
      <div class="video-container" @click.stop>
        <video 
          ref="videoPlayer"
          :src="interviewVideo" 
          controls 
          autoplay
        ></video>
        <div class="close-btn" @click="closeVideo">×</div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeCarousel from '@/components/Carousel.vue'
import { getBannerList, getCompanyInfo, getHotTopicList } from '@/api/home'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'HomeView',
  components: {
    HomeCarousel
  },
  data() {
    return {
      banners: [],
      srcicon: require('../assets/home/gengduosmall.png'),
      defaultIcon: require('../assets/home/gengduosmall.png'),
      hoverIcon: require('../assets/home/gengduo.png'),
      srcicon1: require('../assets/home/gengduosmall.png'),
      defaultIcon1: require('../assets/home/gengduosmall.png'),
      hoverIcon1: require('../assets/home/gengduo.png'),

      companyInfo: {
        description: '',
        group: ''
      },
      recruitmentList: [],
      courseList: [],
      expertList: [],
      interview: [],
      recommendList: [],
      interviewUrl: '',
      interviewVideo: '',
      showVideoModal: false,
      en: false,
    }
  },
  created() {
    this.getBanners()
    this.getCompanyInfo()
    this.getHotTopicList()
    this.$watch('$i18n.locale', (newVal) => {
      console.log('Language changed to:', newVal)
      // 更新 Vant 组件语言
      if (newVal === 'en') {
        this.en = true
      } else {
        this.en = false
      }
    }, { immediate: true })
  },

  mounted() {
    // 初始化 AOS
    AOS.init({
      duration: 1000,    // 动画持续时间
      once: true,        // 动画是否只执行一次
      offset: 100,       // 触发动画的位置
      easing: 'ease-in-out-cubic' // 动画曲线
    })
  },
  methods: {
    startLanguageCheck() {
      // 设置定时任务，每秒检查一次
      this.intervalId = setInterval(() => {
        const currentLang = localStorage.getItem('userLanguage');
        if (this.lang !== currentLang) {
          this.lang = currentLang || 'zh'; // 如果语言变化，更新lang的值
        }
      }, 1000); // 检查间隔为1秒，可以根据需要调整
      console.log('this.lang',this.lang)
    },
    async getBanners() {
      try {
        const res = await getBannerList()
        this.banners = res.data.filter(item => item.type === 1)
      } catch (error) {
        console.error('获取轮播图数据败:', error)
      }
    },
    async getCompanyInfo() {
      try {
        const res = await getCompanyInfo()
        this.companyInfo = {
          ...res.data,
          description: res.data.description.replace(/\n/g, '<br>'),
          descriptionen: res.data.descriptionen.replace(/\n/g, '<br>')
        }
        localStorage.setItem('description', this.companyInfo.description); // 保存用户选择的语言
        localStorage.setItem('descriptionen', this.companyInfo.descriptionen); // 保存用户选择的语言
      } catch (error) {
        console.error('取公司信息失败:', error)
      }
    },

    async getHotTopicList() {
      try {
        const res = await getHotTopicList()
        this.recruitmentList = res.data.job
        console.log('this.recruitmentList', this.recruitmentList)
        this.recommendList = res.data.recommend
        console.log('this.recommendList', this.recommendList)
        this.courseList = res.data.course
        console.log('this.courseList', this.courseList)
        this.expertList = res.data.pool
        console.log('this.expertList', this.expertList)
        this.interview = res.data.interview
        console.log('this.interview', this.interview)
        if (this.interview.length > 0) {
          console.log(111111)
          this.interviewUrl = res.data.interview[0].url
          this.interviewVideo = res.data.interview[0].video
        }

      } catch (error) {
        console.error('获取热门专题失败:', error)
      }
    },

    scrollToSection(sectionId) {
      // 如果已经在集团概括页面
      if (this.$route.path === '/group') {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      } else {
        // 如果不在集团概括页面，先跳转再滚动
        this.$router.push('/group').then(() => {
          // 添加一个小延时确保 DOM 已经更新
          setTimeout(() => {
            const element = document.getElementById(sectionId)
            if (element) {
              element.scrollIntoView({  block: 'center',behavior: 'smooth' })
            }
          }, 300) // 100ms 延时，可以根据实际情况调整
        })
      }
    },
    // async getTopicLists() {
    //   try {
    //     const res = await getTopicLists()
    //     this.recruitmentList = res.data.recruitment
    //     this.recommendList = res.data.recommend
    //     this.courseList = res.data.course
    //   } catch (error) {
    //     console.error('获取专题列表失败:', error)
    //   }
    // },
    playVideo() {
      this.showVideoModal = true
    },
    
    closeVideo() {
      this.showVideoModal = false
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
      }
    },
    viewzhaopin(item) {
      // 将详情数据存储到 localStorage
      localStorage.setItem('jobDetail', JSON.stringify({
        id: item.id,
        title: item.title,
        content: item.content,
        createtime: item.createtime,
        url: item.url
      }))
      console.log('进入这里')
      // 跳转到详情页，只传递 ID
      this.$router.push({
        path: `/talent/recruitment/detail/${item.id}`
      })
    },

    viewtuijian(item) {
      // 将详情数据存储到 localStorage
      localStorage.setItem('jobDetail', JSON.stringify({
        id: item.id,
        title: item.title,
        content: item.content,
        createtime: item.createtime,
        url: item.url
      }))
      
      // 跳转到详情页，只传递 ID
      this.$router.push({
        path: `/talent/recommend/detail/${item.id}`
      })
    },

    viewcourse(item) {
      // 如果是 VIP 课程且用户不是 VIP
      if (item.free === 2 && !this.isvip) {
        this.$message({
          message: '该课程仅限 VIP 用户观看，请先开通 VIP',
          type: 'warning'
        })
        return
      }

      // 存储详情数据到 localStorage
      localStorage.setItem('coursesDetail', JSON.stringify({
        id: item.id,
        title: item.title,
        content: item.content,
        createtime: item.createtime,
        video: item.video,
        url: item.url
      }))
      
      // 跳转到详情页
      this.$router.push({
        path: `/courses/detail/${item.id}`
      })
    },

    viewDetail(item) {
      // 将详情数据存储到 localStorage
      localStorage.setItem('policyDetail', JSON.stringify({
        id: item.id,
        name: item.name,
        description: item.description,
        type: item.type,
        category: item.category
      }))
      
      // 跳转到详情页，只传递 ID
      this.$router.push({
        path: `/expert/detail/${item.id}`
      })
    },

        // 添加富文本过滤方法
        filterRichText(html) {
      if (!html) return ''
      
      // 创建临时 div 元素
      const temp = document.createElement('div')
      temp.innerHTML = html
      
      // 移除所有图片标签
      const images = temp.getElementsByTagName('img')
      while (images.length > 0) {
        images[0].parentNode.removeChild(images[0])
      }
      
      // 移除所有视频标签
      const videos = temp.getElementsByTagName('video')
      while (videos.length > 0) {
        videos[0].parentNode.removeChild(videos[0])
      }
      
      // 移除所有音频标签
      const audios = temp.getElementsByTagName('audio')
      while (audios.length > 0) {
        audios[0].parentNode.removeChild(audios[0])
      }
      
      // 移除所有 iframe 标签
      const iframes = temp.getElementsByTagName('iframe')
      while (iframes.length > 0) {
        iframes[0].parentNode.removeChild(iframes[0])
      }
      
      // 获取纯文本内容
      let text = temp.textContent || temp.innerText
      
      // 去除多余空格和换行
      text = text.replace(/[\n\r]+/g, ' ').replace(/\s+/g, ' ').trim()
      
      return text
    },
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  background: #F6F7F9;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 0 20px; */
}

.company-intro {
  padding: 60px 0;
}

.intro-top {
  text-align: left;
  margin-bottom: 80px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo-wrapper {
  margin-bottom: 20px;
}

.company-logo {
  width: 292px;
  height: 119px;
  object-fit: contain;
}

.intro-text {
  width: 620px;
  height: 280px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #302929;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  margin-bottom: 50px;
  overflow: auto;
  white-space: pre-line;
}

.action-buttons {
  display: flex;
  justify-content: start;
  gap: 20px;
  margin-bottom: 60px;
}

.action-btn {
  display: flex;
  align-items: center;
  padding: 12px 15px 12px 30px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  background: #F6F7F9;
  border-radius: 28px;
  border: 1px solid #BDBDBD;
  color: #333;
}

.action-btn:hover,
.action-btn.router-link-active {
  background-color: #3379F2;
  color: #FFFFFF;
  border-color: #3379F2;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.intro-bottom {
  position: relative;
  /* margin: 0 -20px; */
}

.blue-block {
  background-color: #3379F2;
  padding: 60px;
  max-height: 240px;
  display: flex;
  align-items: center;
}

.text-content {
  color: #FFFFFF;
  max-width: 1200px;
  padding: 0 20px;
  text-align: left;
  position: relative;
}

.text-content h2 {
  font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 24px;
color: #FFFFFF;
line-height: 33px;
text-align: left;
font-style: normal;
}

.text-content p {
  margin-top: 15px;
  font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 16px;
color: #FFFFFF;
line-height: 22px;
text-align: left;
font-style: normal;
}

.image-container {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 41%;
  max-width: 600px;
  height: auto;
}

.building-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.circle-arrow {
  position: absolute;
  right: -60px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.arrow-icon {
  width: 36px;
  height: 36px;
}

.circle-arrow:hover {
  transform: translateY(-50%) scale(1.1);
}

.topic-list-header {
  width: 100%;
  font-size: 0;
  line-height: 0;
}

.topic-list-img {
  width: 100%;
  height: 220px;
  display: block;
  object-fit: cover;
}

.topic-list-title {
  width: 100%;
  height: 100px;
  text-align: left;
  background: #FFFFFF;
  box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.05);
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.topic-list-title h2 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #212121;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  margin-bottom: 19px;
  transition: color 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topic-list-title span {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #212121;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  transition: color 0.3s ease;
}

.topic-list-title img {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 20px;
  /* top: 50%; */
  /* transform: translateY(-50%); */
  opacity: 0;
  transition: opacity 0.3s ease;
}

.topic-list-title:hover {
  background: #3379F2;
  box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.05);
}

.topic-list-title:hover h2,
.topic-list-title:hover span {
  color: #FFFFFF;
}

.topic-list-title:hover img {
  opacity: 1;
  filter: brightness(0) invert(1);
}

@media screen and (max-width: 1024px) {
  .image-container {
    width: 40%;
  }
  
  .text-content h2 {
    font-size: 28px;
  }
  
  .text-content p {
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  .main-content {
    padding: 0 15px;
  }
  
  .company-intro {
    padding: 40px 0;
  }
  
  .intro-text {
    width: 100%;
    height: auto;
    max-height: 280px;
    font-size: 16px;
    line-height: 32px;
  }
  
  .company-logo {
    width: 200px;
    height: auto;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .action-btn {
    width: 200px;
  }
  
  .blue-block {
    padding: 40px 20px;
  }
  
  .image-container {
    position: relative;
    width: 100%;
    max-width: none;
    height: auto;
    margin-top: -60px;
  }
  
  .text-content h2 {
    font-size: 24px;
  }
  
  .text-content p {
    font-size: 16px;
  }
  
  .circle-arrow {
    right: 0;
    width: 36px;
    height: 36px;
  }
  
  .products-services {
    padding: 50px 0;
  }
  
  .en-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 30px;
    color: #B0B0B0;
    line-height: 42px;
    text-align: right;
    font-style: normal;
  }
  
  .cn-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 30px;
    color: #484848;
    line-height: 42px;
    text-align: right;
    font-style: normal;
  }
}

/* 大屏幕 (2560px 及以上) */
@media screen and (min-width: 2560px) {
  .main-content {
    max-width: 1200px;
  }
  
  .intro-text {
    /* width: 800px; */
    /* font-size: 20px; */
    /* line-height: 44px; */
  }
  
  .company-logo {
    width: 350px;
    height: 142px;
  }
  
  .text-content h2 {
    font-size: 38px;
  }
  
  .text-content p {
    font-size: 24px;
  }
}

/* 1440px - 1919px */
@media screen and (max-width: 1919px) {
  .main-content {
    max-width: 1200px;
  }
  
  .intro-text {
    width: 580px;
    font-size: 17px;
    line-height: 38px;
  }
  
  .company-logo {
    width: 260px;
    height: 106px;
  }
  
  .text-content h2 {
    font-size: 30px;
  }
  
  .text-content p {
    font-size: 18px;
  }
}

/* 1280px - 1439px */
@media screen and (max-width: 1439px) {
  .main-content {
    max-width: 1100px;
  }
  
  .intro-text {
    width: 520px;
    font-size: 16px;
    line-height: 36px;
  }
  
  .company-logo {
    width: 240px;
    height: 98px;
  }
  
  .image-container {
    width: 38%;
  }
}

/* 1024px - 1279px */
@media screen and (max-width: 1279px) {
  .main-content {
    max-width: 960px;
  }
  
  .intro-text {
    width: 480px;
    font-size: 15px;
    line-height: 34px;
  }
  
  .company-logo {
    width: 220px;
    height: 90px;
  }
  
  .image-container {
    width: 35%;
  }
  
  .text-content h2 {
    font-size: 28px;
  }
  
  .text-content p {
    font-size: 16px;
  }
  
  .action-btn {
    padding: 10px 35px;
    font-size: 15px;
  }
}

/* 平板 (768px - 1023px) */
@media screen and (max-width: 1023px) {
  .main-content {
    max-width: 90%;
  }
  
  .intro-text {
    width: 100%;
    max-width: 460px;
    font-size: 14px;
    line-height: 32px;
  }
  
  .company-logo {
    width: 200px;
    height: 82px;
  }
  
  .blue-block {
    padding: 50px 40px;
  }
  
  .text-content h2 {
    font-size: 26px;
  }
  
  .text-content p {
    font-size: 15px;
  }
}

/* 手机横屏 (576px - 767px) */
@media screen and (max-width: 767px) {
  .intro-text {
    height: auto;
    max-height: 280px;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .action-btn {
    width: 180px;
    text-align: center;
  }
  
  .image-container {
    position: relative;
    width: 100%;
    margin-top: -40px;
  }
}

/* 手机竖屏 (375px - 575px) */
@media screen and (max-width: 575px) {
  .main-content {
    max-width: 95%;
  }
  
  .company-logo {
    width: 180px;
    height: 73px;
  }
  
  .blue-block {
    padding: 40px 20px;
  }
  
  .text-content h2 {
    font-size: 22px;
  }
  
  .text-content p {
    font-size: 14px;
  }
}

/* 小屏手机 (375px以下) */
@media screen and (max-width: 374px) {
  .company-logo {
    width: 160px;
    height: 65px;
  }
  
  .intro-text {
    font-size: 13px;
    line-height: 28px;
  }
  
  .action-btn {
    width: 160px;
    padding: 8px 30px;
    font-size: 14px;
  }
  
  .text-content h2 {
    font-size: 20px;
  }
  
  .text-content p {
    font-size: 13px;
  }
}

.products-services {
  padding: 80px 0;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.en-title {
  font-family: Arial;
  font-size: 30px;
  color: #999999;
  line-height: 30px;
  margin-bottom: 8px;
  font-weight: normal;
}

.cn-title {
  font-family: PingFangSC, PingFang SC;
  font-size: 30px;
  color: #333333;
  line-height: 45px;
  font-weight: 600;
}

.service-container {
  margin-top: 60px;
  width: 100%;
}

.service-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

/* 一行布局 */
.service-row:first-child {
  width: calc(100% - 28px);  /* 减去一个距，确保右对 */
}

.service-row:first-child .service-item.large {
  width: calc(66.666% + 12px);  /* 两份宽度加上一半间距 */
  flex: none;
}

.service-row:first-child .service-item:last-child {
  width: calc(33.333% - 12px);  /* 一份宽度减去一半间距 */
  flex: none;
}

/* 第二行布局 */
.service-row:last-child .service-item {
  width: calc(33.333% - 16px);  /* 三等分减去距 */
  flex: none;
}

.service-item {
  position: relative;
  height: 280px;
  flex: 1;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.service-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.service-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.service-content {
  position: absolute;
  left: 30px;
  top: 50px;
  bottom: 40px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(100% - 90px);
}

.service-en-title {
  font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 18px;
color: #FFFFFF;
line-height: 25px;
letter-spacing: 2px;
text-align: left;
font-style: normal;
}

.service-cn-title {
  font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 24px;
color: #FFFFFF;
line-height: 33px;
text-align: left;
font-style: normal;
}

.learn-more {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 8px 24px;
  background: transparent;
  font-family: PingFangSC, PingFang SC;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 16px;
  transition: all 0.3s ease;
  text-align: left;
  border: 1px solid #FFFFFF;
  display: flex;
  align-items: center;
  gap: 8px;
}

.learn-more img {
  width: 16px;
  height: 16px;
  display: block;
}

.learn-more:hover {
  background: #FFFFFF;
  color: #333333;
  transform: translateY(-2px);
}

.learn-more:hover img {
  filter: brightness(0);
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .service-row {
    flex-direction: column;
    gap: 16px;
  }
  
  .service-item {
    height: 200px;
  }
  
  .service-content {
    left: 20px;
    bottom: 20px;
  }
  
  .service-cn-title {
    font-size: 20px;
  }
}

.gradient-1 {
  background: linear-gradient(270deg, rgba(102,108,221,0.2) 0%, rgba(161,221,235,0.9) 88%, #A1DDEB 100%);
}

.gradient-2 {
  background: linear-gradient(270deg, rgba(18,101,227,0) 0%, #0A3786 100%);
}

.gradient-3 {
  background: linear-gradient(230deg, #088A84 0%, rgba(20,190,186,0.17) 100%);
}

.gradient-4 {
  background: linear-gradient(230deg, rgba(78,14,209,0.4) 0%, rgba(13,6,165,0.71) 100%);
}

.gradient-5 {
  background: linear-gradient(228deg, rgba(255,161,47,0.91) 0%, rgba(255,207,92,0.19) 100%);
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}

.topic-container {
  display: flex;
  gap: 60px;
  width: 100%;
  margin-top: 60px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.topic-container > * {
  flex: 1 1 calc(33.333% - 40px); /* 每个子元素占据的宽度 */
  box-sizing: border-box; /* 包括内边距和边框在内计算元素的总宽度和高度 */
  margin-bottom: 60px; /* 子元素之间的垂直间��� */
}

.topic-item {
  flex: 1;
  /* min-width: 300px; */
  /* max-width: 360px; */
  width: calc(33.333% - 40px);
  margin-bottom: 30px;
  transition: all 0.3s ease-in-out;
}

/* 注释掉下面的内容 */
/* .topic-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
} */

.topic-header {
  text-align: left;
}

.topic-line-wrapper {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
  /* gap: 16px; */
}

.topic-line1 {
  background: linear-gradient( 270deg, #63B1FA 0%, #3379F2 100%);
  height: 5px;
  width: 60px;
}

.topic-line2 {
  border: 1px solid #DBDBDB;
  height: 1px;
  width: 100%;
}

.topic-cn-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #484848;
  line-height: 33px;
  display: inline-block;
  font-family: PingFangSC, PingFang SC;
  position: relative;
}

.topic-cn-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: #3379F2;
  transition: width 0.3s ease-in-out;
}

.topic-header:hover .topic-cn-title::after {
  width: 100%;
}

.topic-en-title {
  font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 16px;
color: #B0B0B0;
line-height: 22px;
text-align: left;
font-style: normal;
  display: inline-block;
  margin-left: 8px;
}

.topic-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.topic-list-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  flex-wrap: wrap;
  border-bottom: 1px solid #DBDBDB;
  cursor: pointer;
}

/* .topic-list-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #DBDBDB;
} */

.topic-list-item .date {
  min-width: 100px;
  border: 1px solid #E0E0E0;
  padding: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #3379F2;
  line-height: 20px;
  text-align: right;
  font-style: normal;
}

.topic-list-item .title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #212121;
  line-height: 25px;
  font-style: normal;
  text-align: left;
}

.topic-list-item:hover .title {
  color: #3379F2;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .topic-container {
    gap: 30px;
  }
  
  /* .topic-item {
    flex: 0 1 calc(50% - 15px);
  } */
}

@media screen and (max-width: 768px) {
  .topic-container {
    gap: 20px;
  }
  
  .topic-item {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

/* 调整列表项的响应式布局 */
.topic-list-header {
  width: 100%;
}

.topic-list-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
}

.topic-list-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  flex-wrap: wrap;
}

@media screen and (max-width: 480px) {
  .topic-list-header .topic-list-title h2 {
    font-size: 16px;
    line-height: 22px;
  }
  
  .topic-list-item .date {
    min-width: 80px;
    padding: 8px;
    font-size: 12px;
  }
  
  .topic-list-item .title {
    font-size: 14px;
    line-height: 20px;
  }
  
  .topic-list-img {
    height: 180px;
  }
}

.expert-database {
  padding: 80px 0;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
}

.view-more {
  position: absolute;
  right: 0;
  top: 70%;
  transform: translateY(-50%);
  font-family: PingFangSC, PingFang SC;
  cursor: pointer;
  transition: all 0.3s ease;
font-weight: 400;
font-size: 14px;
color: #787878;
line-height: 20px;
text-align: left;
font-style: normal;
}

.title-wrapper {
  position: relative;
}

.title-left {
  text-align: center;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .expert-database {
    padding: 50px 20px;
  }
  
  .view-more {
    font-size: 14px;
  }
}

/* 人才专家库样式 */
.expert-container {
  display: flex;
  gap: 20px;
  margin-top: 30px;
  padding-bottom: 80px;
}

/* 左侧视频区域 */
.expert-video {
  width: calc(50% - 10px);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.video-wrapper {
  position: relative;
  width: 100%;
  height: 340px;
  aspect-ratio: 16/9;  /* 使用视频标准比例 */
  overflow: hidden;
  cursor: pointer;
}

.video-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}

.play-button img {
  width: 72px;
  height: 72px;
  transition: transform 0.3s ease-in-out;
}

.video-wrapper:hover .play-button {
  background: rgba(0,0,0,0.6);
}

.video-wrapper:hover .play-button img {
  transform: scale(1.1);
}

.video-title-wrapper {
  height: 100px;
  background: #FFFFFF;
  box-shadow: 0px 5px 4px 0px rgba(0,0,0,0.05);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.video-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #212121;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.video-date {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #888888;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  margin-top: 10px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
}

.video-date img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

/* 右侧专家列表 */
.expert-list {
  width: calc(50% - 10px);
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}



.expert-item {
  width: calc(50% - 10px);
  height: 100px;
  padding: 15px;
  background: #FFFFFF;
  box-shadow: 0px 5px 4px 0px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.expert-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.expert-info {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
}

.expert-name {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #212121;
  line-height: 25px;
  margin-right: 8px;
  flex-shrink: 0;
}

.expert-tags {
  display: flex;
  gap: 8px;
  overflow: hidden;
  flex-wrap: nowrap;
}

.tag {
  flex-shrink: 0;
  background: linear-gradient( 132deg, #F6C3AA 0%, #B78355 100%);
border-radius: 4px;
}

.tag.talent {
  background: linear-gradient(132deg, #AEC2FF 0%, #3379F2 100%);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 12px;
color: #FFFFFF;
line-height: 17px;
text-align: left;
font-style: normal;
padding: 2px 8px;
}

.tag.expert {
  background: linear-gradient(132deg, #F6C3AA 0%, #B78355 100%);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 12px;
color: #FFFFFF;
line-height: 17px;
text-align: left;
font-style: normal;
padding: 2px 8px;
}

.tag:not(:first-child) {
  padding: 2px 8px;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #3379F2;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  background: #DEE6FF;
}

.action-icon {
  width: 24px;
  height: 24px;
  margin-left: 10px;
}

.expert-desc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #888888;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

/* 响应式调整 */
@media screen and (max-width: 1200px) {
  .expert-list {
    gap: 15px;
  }
  
  .expert-item {
    width: calc(50% - 7.5px);
  }
}

@media screen and (max-width: 768px) {
  .expert-list {
    width: 100%;
  }
  
  .expert-item {
    width: 100%;
  }
}

.tag.more {
  margin-left: auto;
}

.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 40px;
}

.video-container {
  position: relative;
  width: 100%;
  max-width: 800px;  /* 减小最大宽度 */
  max-height: 80vh;  /* 限制最大高度为视窗高度的80% */
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-container video {
  width: 100%;
  height: 100%;
  max-height: calc(80vh - 40px); /* 确保视频不会超出容器 */
  object-fit: contain; /* 保持视频比例 */
  display: block;
}

.quexingimg img{
    width: 100%;
    height: 100%;
  }

.close-btn {
  position: absolute;
  top: -36px;
  right: 0;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.close-btn:hover {
  transform: scale(1.1);
  background: rgba(0, 0, 0, 0.8);
}

@media screen and (max-width: 768px) {
  .video-modal {
    padding: 20px;
  }
  
  .video-container {
    max-height: 85vh;
  }
  
  .video-container video {
    max-height: calc(85vh - 20px);
  }
  
  .close-btn {
    top: -30px;
    font-size: 20px;
    width: 30px;
    height: 30px;
  }


}
</style> 